import { render, staticRenderFns } from "./BlockFullBackgroundWithButtons.vue?vue&type=template&id=220fefb9&"
import script from "./BlockFullBackgroundWithButtons.vue?vue&type=script&lang=js&"
export * from "./BlockFullBackgroundWithButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports